// extracted by mini-css-extract-plugin
export const card = "Card-module--card--3D-98";
export const cardGrid = "Card-module--cardGrid--3uLpq";
export const projectCard = "Card-module--projectCard--pBaXV Card-module--card--3D-98";
export const projectCardContent = "Card-module--projectCardContent--2TVRq";
export const projectCardImage = "Card-module--projectCardImage--3pJkx";
export const projectCardEmoji = "Card-module--projectCardEmoji--3DZZ2";
export const projectCardTitle = "Card-module--projectCardTitle--2CFDf";
export const projectCardDescription = "Card-module--projectCardDescription--3Kttp";